import { ref } from 'vue'
import type { Ref } from 'vue'

import type { BuildPreset, BuildPresetLibrary, PlayerBuildPresetOwner } from '../../types'

export interface BuildPresetStateApi {
  readonly playerBuildPresetOwners: Ref<ReadonlyArray<PlayerBuildPresetOwner>>
  readonly guildBuildPresets: Ref<ReadonlyArray<BuildPreset>>
  readonly myBuildPresets: Ref<ReadonlyArray<BuildPreset>>
  readonly myBuildPresetsLoading: Ref<boolean>
  readonly myBuildPresetsError: Ref<string | null>
  readonly applyLibrary: (library: BuildPresetLibrary) => void
  readonly clearLibrary: () => void
}

export function useBuildPresetState(): BuildPresetStateApi {
  const playerBuildPresetOwners = ref<ReadonlyArray<PlayerBuildPresetOwner>>([])
  const guildBuildPresets = ref<ReadonlyArray<BuildPreset>>([])
  const myBuildPresets = ref<ReadonlyArray<BuildPreset>>([])
  const myBuildPresetsLoading = ref<boolean>(false)
  const myBuildPresetsError = ref<string | null>(null)

  function applyLibrary(library: BuildPresetLibrary): void {
    playerBuildPresetOwners.value = library.playerPresets
    guildBuildPresets.value = library.guildPresets
  }

  function clearLibrary(): void {
    playerBuildPresetOwners.value = []
    guildBuildPresets.value = []
  }

  return {
    playerBuildPresetOwners,
    guildBuildPresets,
    myBuildPresets,
    myBuildPresetsLoading,
    myBuildPresetsError,
    applyLibrary,
    clearLibrary,
  }
}
